<template>
    <div class="ourserve-box">
        <!-- 行走的线 -->
        <div class="animetionLine"></div>
        <div class="text-box">
            <h3 class="caption black">{{serveData.caption}}</h3>
            <p class="title black">{{serveData.title}}</p>
            <div class="button black" @click='toPath(serveData.baseurl)'></div>
        </div>
        <div class="swiper-box oneswiper">
            <Swiperbox :swiperData='serveData.swiperData' :baseUrl='serveData.baseurl' :swiperOptions='swiperOptions'
                :scrollbar='scrollbar' ref='childModle'>
            </Swiperbox>
        </div>
        <div class="swiper-box twoswiper">
            <Swiperbox :swiperData='serveData.swiperData' :swiperOptions='swiperOptionstwo' :scrollbar='scrollbar'
                ref='childModle1'>
            </Swiperbox>
        </div>
    </div>
</template>
<script>
    import Swiperbox from '@/components/base/swiper'//引入swiper
    export default {
        name: 'OurServe',
        props: {
            serveData: Object,
            swiperOptions: Object,
            scrollbar: String
        },
        components: {
            Swiperbox
        },
        data() {
            return {

                swiperOptionstwo: {
                    autoplay: { //匀速滚动
                        delay: 1, //间隔时间0秒
                        stopOnLastSlide: false,
                        disableOnInteraction: false, //触摸后仍然执行
                    },
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        // hide: true,
                        draggable: true,
                    },
                    loop: true,
                    speed: 16000,  //设置图片滚动速度
                    slidesPerView: 1,
                    spaceBetween: 10,
                    // freeMode: true,
                    grabCursor: true,
                    // centeredSlides: true,
                    // Some Swiper option/callback...
                },
            }
        },
        methods: {
            toPath(url) {
                if (url == null) {
                    this.$refs.childModle.toPath(url)
                } else {
                    window.location.href = url
                }
            },
        }
    }
</script>
<style scoped>
    .ourserve-box {
        width: 100%;
        margin-top: 250px;
        min-height: 952px;
        margin-bottom: 366px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/%E7%BB%84%20767.jpg') no-repeat center center;
        background-size: cover;
        background-attachment: fixed;
        position: relative;
        display: grid;
        grid-template-columns: 32% 68%;
        z-index: 0;
    }

    .ourserve-box::after {
        position: absolute;
        top: 0;
        left: 0;
        content: '';
        width: 100%;
        height: 100%;
        display: block;
        background-color: rgba(0, 0, 0, .3);
        z-index: 2;
    }

    .ourserve-box::before {
        content: 'Case Show';
        text-transform: uppercase;
        display: none;
        position: absolute;
        font-size: 14px;
        font-weight: bold;
        color: #999999;
        top: 290px;
        left: 48px;
        z-index: 3;
        transform: rotate(90deg);
    }

    .text-box {
        padding: 0;
        padding-left:10%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .caption {
        font-size: 64px;
        font-weight: bold;
        line-height: 78px;
        color: rgba(255, 255, 255, 1);
        position: relative;
        max-width: 250px;
        z-index: 3;
        /* letter-spacing:50px; */
    }

    .title {
        margin-top: 36px;
        font-size: 16px;
        font-weight: bold;
        line-height: 40px;
        color: rgba(249, 249, 249, 1);
        position: relative;
        max-width: 297px;
        z-index: 3;
    }

    .button {
        position: relative;
        border: 2px solid #ffffff;
        width: 40px;
        height: 40px;
        z-index: 3;
        border-radius: 50%;
        margin-top: 95px;
        cursor: pointer;
        transition: all 0.5s;
    }

    .button::after {
        content: '';
        height: 2px;
        width: 2px;
        background-color: #ffffff;
        position: absolute;
        top: 50%;
        left: 50%;
        box-shadow: -6px 0 #ffffff;
        transform: translate(-50%, -50%);
    }

    .button::before {
        content: '';
        height: 2px;
        width: 2px;
        background-color: #ffffff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(250%, -50%);
        transition: all 0.5s;
    }

    .button:hover {
        width: 80px;
        border-radius: 40px;
    }

    .button:hover::after {
        content: 'MORE';
        color: #ffffff;
        height: auto;
        width: auto;
        background-color: transparent;
        box-shadow: none;
    }

    .button:hover::before {
        display: none;
    }

    .swiper-box {
        position: relative;
        align-self: flex-end;
        background-color: #ffffff;
        width: 100%;
        height: 840px;
        transform: translateY(108px);
        z-index: 3;
        padding: 100px 0 55px 100px;
        overflow: hidden;
    }

    .animetionLine {
        width: 20px;
        height: 250px;
        position: absolute;
        top: 250px;
        left: 60px;
        /* transform: rotate(90deg); */
        z-index: 3;
        overflow: hidden;
        display: none;
        /* background-color:red; */
    }

    .animetionLine::after {
        content: '';
        display: none;
        /* transform: rotate(90deg); */
        width: 1px;
        height: 250px;
        background-color: #999999;
        position: absolute;
        top: 0px;
        right: 50%;
        animation: linearMotion 2.5s infinite;
    }

    .twoswiper {
        display: none;
    }

    /* 线条运动 */
    @keyframes linearMotion {
        from {
            top: -250px;
        }

        to {
            top: 250px;
        }
    }

    @media(max-width: 995px) {
        .ourserve-box {
            width: 100%;
            min-height: auto;
            background-attachment: initial;
            grid-template-columns: 100%;
            margin-bottom: 50px;
        }

        .oneswiper {
            display: none;
        }

        .twoswiper {
            display: block;
        }

        .text-box {
            padding: 5%;
        }

        .swiper-box {
            width: 100%;
            height: auto;
            transform: translateY(0px);
            padding: 0%;
            /* padding-left:5%; */
        }

        .button {
            margin: 5% auto 0;
            /* position: relative;
        border: 2px solid #ffffff;
        width: 40px;
        height: 40px;
        z-index: 3;
        border-radius: 50%;
        margin-top: 95px;
        cursor: pointer;
        transition: all 0.5s; */
        }
    }

    /* @media(max-width: 1023px) {
        .ourserve-box {
            width: 100%;
            background-attachment: initial;
            grid-template-columns: 100%;
        }

        .oneswiper {
            display: none;
        }

        .twoswiper {
            display: block;
            height: 1500px;
            padding: 100px 50px;
        }

        .title {
            font-size: 50px;
            line-height: 150%;
            max-width: 80%;
        }

        .button {
            width: 150px;
            height: 150px;
        }

        .button::after {
            content: '';
            height: 2px;
            width: 2px;
            background-color: #ffffff;
            position: absolute;
            top: 50%;
            left: 50%;
            box-shadow: -20px 0 #ffffff;
            transform: translate(-50%, -50%);
        }

        .button::before {
            content: '';
            height: 2px;
            width: 2px;
            background-color: #ffffff;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(250%, -50%);
            transition: all 0.5s;
        }

        .button:hover {
            width: 300px;
            border-radius: 100px;
        }

        .button:hover::after {
            font-size: 40px;
        }
        
    }
    @media(max-width: 375px){
        .twoswiper {
            height: 1900px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/home/ourserve.vue